<template>
  <v-row class="justify-center plus-minus-input">
    <v-flex xs12 v-if="$vuetify.breakpoint.xs">
    <input
      class="ticket-count-input"
      :value="inputValue"
      type="text"
      @keydown="checkIsNumber"
      @input.prevent="change($event)"
    />
    </v-flex>

    <v-btn class="remove-ticket" @click="remove" color="primary" outlined>
      <v-icon center>remove</v-icon>
    </v-btn>
    <input
      class="ticket-count-input"
      v-if="!$vuetify.breakpoint.xs"
      :value="inputValue"
      type="text"
      @keydown="checkIsNumber"
      @input.prevent="change($event)"
    />
    <v-btn class="add-ticket" @click="add" color="primary" outlined>
      <v-icon center>add</v-icon>
    </v-btn>
  </v-row>
</template>

<script>
export default {
  name: 'PlusMinusInput',
  components: {},
  props: {
    max: {
      type: Number,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    inputValue: function() {
      return this.value;
    },
  },
  methods: {
    add() {
      this.$emit('change', this.inputValue + 1);
    },
    remove() {
      this.$emit('change', this.inputValue - 1);
    },
    change: function(event) {
      let value = parseInt(event.target.value);

      if (isNaN(value)) {
        value = 0;
      }

      if (value <= 0) {
        value = 0;
      }

      if (value > this.max) {
        value = this.max;
      }

      event.target.value = value;
      this.$emit('change', value);
    },
    checkIsNumber(event) {
      if ([69, 187, 188, 189, 190].includes(event.keyCode)) {
        event.preventDefault();
      }
    },
  },
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
.plus-minus-input {
  height: 40px;
  width: 100%;
  text-align: center;
  padding: 12px 0;

  .add-ticket,
  .remove-ticket,
  .ticket-count-input,
  .v-btn,
  .v-text-field__slot {
    min-height: 0px;
    height: 36px;
    width: 32px;
    margin-left: 4px;
    margin-right: 4px;
  }

  .v-btn:not(.v-btn--round).v-size--default {
    min-width: 0px;
  }

  .ticket-count-input {
    background: white;
    text-align: center;
    border: 1px solid #005a28;
  }
}

.minimalHeight {
  .add-ticket,
  .remove-ticket {
    margin-top: 5px;
  }

  .ticket-count-input {
    width: 74px !important;
  }
}
</style>
